import { headerTextStyles } from './text-styles';
import { TextProps } from '@features/powerpoint';

export const contentSlideHeader = (
  title: TextProps['text'],
  options?: TextProps['options']
): TextProps => ({
  text: title,
  options: { ...headerTextStyles.contentSlide, ...options },
});
